import React, { useEffect, useState } from "react";
import "./stylesUsersByState.css";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";

import dayjs from "dayjs";
import GeographicUserInsights from "../../../CommonComponents/Dashboard/GeographicUserInsights/GeographicUserInsights";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";

function UsersByState() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];
  const [dates, setDates] = useState(thisMonthRange);
  const [usersByStateData, setUsersByStateData] = useState([
    {
      name: "California",
      abbr: "CA",
      amount: 7294,
    },
    {
      name: "Washington",
      abbr: "WA",
      amount: 4288,
    },
    {
      name: "Texas",
      abbr: "TX",
      amount: 3993,
    },
    {
      name: "Georgia",
      abbr: "GA",
      amount: 2156,
    },
    {
      name: "Florida",
      abbr: "FL",
      amount: 1942,
    },
    {
      name: "Minnesota",
      abbr: "MN",
      amount: 1115,
    },
    {
      name: "Illinois",
      abbr: "IL",
      amount: 1034,
    },
    {
      name: "Mississippi",
      abbr: "MS",
      amount: 982,
    },
    {
      name: "Alabama",
      abbr: "AL",
      amount: 889,
    },
    {
      name: "South Carolina",
      abbr: "SC",
      amount: 743,
    },
    {
      name: "Wisconsin",
      abbr: "WI",
      amount: 699,
    },
    {
      name: "Missouri",
      abbr: "MO",
      amount: 678,
    },
    {
      name: "North Carolina",
      abbr: "NC",
      amount: 661,
    },
    {
      name: "New Jersey",
      abbr: "NJ",
      amount: 600,
    },
    {
      name: "Pennsylvania",
      abbr: "PA",
      amount: 588,
    },
    {
      name: "Virginia",
      abbr: "VA",
      amount: 567,
    },
    {
      name: "Oregon",
      abbr: "OR",
      amount: 554,
    },
    {
      name: "Massachusetts",
      abbr: "MA",
      amount: 473,
    },
    {
      name: "Ohio",
      abbr: "OH",
      amount: 460,
    },
    {
      name: "Utah",
      abbr: "UT",
      amount: 425,
    },
    {
      name: "Oklahoma",
      abbr: "OK",
      amount: 421,
    },
    {
      name: "Tennessee",
      abbr: "TN",
      amount: 394,
    },
    {
      name: "Indiana",
      abbr: "IN",
      amount: 343,
    },
    {
      name: "Arizona",
      abbr: "AZ",
      amount: 318,
    },
    {
      name: "Colorado",
      abbr: "CO",
      amount: 312,
    },
    {
      name: "Hawaii",
      abbr: "HI",
      amount: 297,
    },
    {
      name: "Kentucky",
      abbr: "KY",
      amount: 249,
    },
    {
      name: "Arkansas",
      abbr: "AR",
      amount: 243,
    },
    {
      name: "Kansas",
      abbr: "KS",
      amount: 213,
    },
    {
      name: "Iowa",
      abbr: "IA",
      amount: 191,
    },
    {
      name: "Nebraska",
      abbr: "NE",
      amount: 175,
    },
    {
      name: "New Mexico",
      abbr: "NM",
      amount: 161,
    },
    {
      name: "South Dakota",
      abbr: "SD",
      amount: 111,
    },
    {
      name: "New Hampshire",
      abbr: "NH",
      amount: 109,
    },
    {
      name: "North Dakota",
      abbr: "ND",
      amount: 109,
    },
    {
      name: "Rhode Island",
      abbr: "RI",
      amount: 93,
    },
    {
      name: "West Virginia",
      abbr: "WV",
      amount: 82,
    },
    {
      name: "Delaware",
      abbr: "DE",
      amount: 68,
    },
    {
      name: "Maine",
      abbr: "ME",
      amount: 48,
    },
    {
      name: "Alaska",
      abbr: "AK",
      amount: 45,
    },
    {
      name: "Washington, D.C.",
      abbr: "DC",
      amount: 38,
    },
    {
      name: "Wyoming",
      abbr: "WY",
      amount: 26,
    },
    {
      name: "Vermont",
      abbr: "VT",
      amount: 14,
    },
    {
      name: "Connecticut",
      abbr: "CT",
      amount: 11,
    },
    {
      name: "New York",
      abbr: "NY",
      amount: 8,
    },
    {
      name: "Maryland",
      abbr: "MD",
      amount: 2,
    },
    {
      name: null,
      abbr: "Guánica",
      amount: 1,
    },
    {
      name: "Michigan",
      abbr: "MI",
      amount: 1,
    },
    {
      name: null,
      abbr: "QC",
      amount: 1,
    },
    {
      name: null,
      abbr: "San Juan",
      amount: 1,
    },
  ]);
  const [top6States, setTop6States] = useState([]);
  const [isApiRunning, setIsApiRunning] = useState(false);

  const getUsersByStateData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    setIsApiRunning(true);

    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_USERS_BY_STATE,
        params
      );

      const data = response?.data?.data?.data;
      const states = data?.map((item) => {
        return item.states.map((state) => ({
          name: state.state,
          abbr: state.state,
          amount: state.count,
        }));
      });

      const combined = states.flat().reduce((acc, curr) => {
        const key = curr.name;
        if (!acc[key]) {
          acc[key] = { name: curr.name, amount: 0 };
        }
        acc[key].amount += curr.amount;
        return acc;
      }, {});

      const result = Object.values(combined);

      const top6 = result.sort((a, b) => b.amount - a.amount).slice(0, 6);

      setUsersByStateData(result);
      setTop6States(top6);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    getUsersByStateData(dates, false);
  }, []);

  return (
    <div className="users-by-state-container">
      <div className="users-by-state-header">
        <h2>Users by State</h2>
        <CustomDatePicker
          getData={getUsersByStateData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>
      <div className="users-by-state-content">
        {isApiRunning ? (
          <div className="loading-container">
            <RebetLoader width={100} height={100} />
          </div>
        ) : (
          <>
            <div className="users-by-state-content-left">
              <GeographicUserInsights
                data={usersByStateData}
                isApiRunning={isApiRunning}
              />
            </div>
            <div className="users-by-state-content-right">
              <div className="states">
                {top6States.map((state) => (
                  <div className="state-item" key={state.name}>
                    <div className="state-item-name">
                      <p>{state.name}</p>
                    </div>
                    <div className="state-item-value">
                      <p>{Intl.NumberFormat("en-US").format(state.amount)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default UsersByState;
